/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Image, Link } from 'rebass'

export default props => (
	<Link target="_blank" href={props.to || "/"} px={[4, 4]} my={[-2, -3]} width={[1 / 2, 1 / 4]}>
		<Image src={props.src} />
	</Link>
)